import {
  IonButton,
  IonButtons,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonGrid,
  IonHeader,
  IonIcon,
  IonRow,
} from '@ionic/react';
import { closeCircleOutline } from 'ionicons/icons';

// Styles
import styles from '@/components/ModalHeader/ReportModalHeader.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

// Types
import type { ComponentProps, PropsWithChildren } from 'react';

interface ReportModalHeaderProps extends ComponentProps<typeof IonHeader> {
  title: string;
  subtitle?: string;
  setShowInfo?: () => void;
  buttons?: boolean;
}

export const ReportModalHeader = ({
  title,
  subtitle,
  setShowInfo,
  buttons,
  ...props
}: PropsWithChildren<ReportModalHeaderProps>) => {
  return (
    <IonHeader className={styles.ReportModal_Header} {...props} mode='ios'>
      <IonGrid className='ion-no-padding' fixed>
        <IonRow className={mergeClassNames('ion-align-items-center', styles['header'])}>
          <IonCol className={styles.content} size='11'>
            <IonCardTitle className={styles.title}>{title}</IonCardTitle>
            {subtitle && <IonCardSubtitle className={styles.subTitle}>{subtitle}</IonCardSubtitle>}
          </IonCol>
          {buttons && setShowInfo && (
            <IonCol className='ion-justify-content-center' size='1'>
              <IonButtons className='ion-justify-content-end ion-padding-end'>
                <IonButton
                  className={styles.modal_Header_Button}
                  fill='clear'
                  onClick={() => setShowInfo()}
                  slot='icon-only'>
                  <IonIcon icon={closeCircleOutline} />
                </IonButton>
              </IonButtons>
            </IonCol>
          )}
        </IonRow>
      </IonGrid>
    </IonHeader>
  );
};
